import { TimeSecEnum } from "src/app/enums/TimeSecEnum"

export class UserSimplifyInfoDTO
{

     Id :number

    /// <summary>
    /// 代號/帳號
    /// </summary>
     Code :string

    /// <summary>
    /// 姓名
    /// </summary>
     Name :string

    /// <summary>
    /// 身分證
    /// </summary>
     CId :string


    FromType :number

    /// <summary>
    /// 職位Id集合
    /// </summary>
    PositionIds :number[]

    /// <summary>
    /// 到職日
    /// </summary>
    ArriveDate :Date

    /// <summary>
    /// 離職日
    /// </summary>
    LeaveDate :Date

    /// <summary>
    /// 專科
    /// </summary>
     MainDept :number

    /// <summary>
    /// 第二專科
    /// </summary>
     SecDept :number
}


export class TherapistScheduleDto
{

    /// <summary>
    /// 代號/帳號
    /// </summary>
    PositionCode :string

    /// <summary>
    /// 姓名
    /// </summary>
     Name :string

    /// <summary>
    /// 身分證
    /// </summary>
     CId :string
     Account:string
       /**時段 */
     TimeSec: TimeSecEnum;
}